<div class="plan-alert notification" *ngIf="notification">
  <div class="d-flex flex-column"> 
  <p>Upgrade Your Plan</p>
  <span>{{ notification.message }}</span>
</div>
<div class="d-flex flex-column align-items-end justify-content-between h-100">
  <button class="close-btn" (click)="dismiss()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="rgba(60,60,60,1)"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path></svg>
  </button>
  <button class="upgrade-btn" (click)="onUpgrade()">Upgrade</button>
</div>
</div>

<!-- <div *ngIf="notification" class="notification" [ngClass]="notification.type">
  <span>{{ notification.message }}</span>
  <button *ngIf="notification.action" (click)="notification.actionCallback?.()">
    {{ notification.action }}
  </button>
  <button class="close" (click)="dismiss()">×</button>
</div> -->